export default __webpack_public_path__ + "static/media/inspiration.fc56540e.png";